import { ReactElement } from 'react';
import { useFeatureFlag } from 'hooks/custom.hooks';

export default function FeatureFlagsWrapper({
	children,
	featureFlag,
}: {
	children: ReactElement;
	featureFlag: string;
}) {
	const isFeatureEnabled = useFeatureFlag(featureFlag);

	if (isFeatureEnabled) return children;
	return null;
}
